{
	"invalidFileFormat": "Format de fichier invalide, formats valides : {{formats}}",
	"multipleFilesUploaded": "Plusieurs fichiers ont été téléchargés",
	"remove": "Supprimer"
}
